import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {map} from 'rxjs/operators';

import {environment} from 'environment';
import {UserInfo} from './models/user-info';
import {RegistrationService } from './services/registration.service';
import {DataStoreService} from 'app/shared/data-store/services/data-store.service';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css'],
})
export class RegistrationComponent implements OnInit {

  public userInfo: UserInfo;
  public voucherCodeValid: boolean;
  public error: string;
  private errorMap: {} = {
    'invalid code': 'Der Voucher Code ist ungültig oder wurde bereits verwendet',
    'invalid email': 'Die gewählte E-Mail Adresse ist ungültig',
    'email already exists': 'Die gewählte E-Mail Adresse existiert bereits',
    'invalid app name': 'Die gewählte Zielplattform ist ungültig',
    'invalid domain': 'Die gewählte Domain ist nicht für Leada freigegeben',
  };

  constructor(private router: Router,
              private route: ActivatedRoute,
              private registrationService: RegistrationService,
              private dataStoreService: DataStoreService) {

    this.userInfo = {
      email: '',
      password: '',
      app: 'iosApp',
      code: null,
    };
    this.voucherCodeValid = false;
  }

  public ngOnInit(): void {
    this.route.params.pipe(map((params) => params['code']))
      .subscribe((code) => {
        this.userInfo.code = code;
        this.checkVoucherCodeValidity();
      });
  }

  public onSubmit(): void {
    this.registrationService.register(this.userInfo)
      .subscribe(
        (result: string) => {

          if (result === 'success') {
            window.location.href = environment.download;

          } else if (result === 'subscribed') {
            this.dataStoreService.email = this.userInfo.email;
            this.router.navigateByUrl('/thank-you');

          }
        },
        (error: Error) => {
          const message: string = error.message;

          if (this.errorMap[message]) {
            this.error = this.errorMap[message];
            return;
          }

          this.error = message;
        },
      );
  }

  private checkVoucherCodeValidity(): void {
    if (!this.userInfo.code) {
      return;
    }

    this.registrationService.isValid(this.userInfo.code)
      .subscribe((isValid: boolean) => {
        if (!isValid) {
          this.router.navigateByUrl('/invalid-voucher');
        }

        this.voucherCodeValid = true;
      });
  }
}
